import React, {Fragment} from "react";
import axios from "axios";
import {connect} from "react-redux";
import {createUser, loadStatus, logOutUser} from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";

import moment from "moment";
import "moment-timezone";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {BASE_URL} from "../constant";
import Loader from "react-loader-spinner";
import {thisExpression} from "@babel/types";
import {Loading} from "./Loading";
import SimpleReactValidator from "simple-react-validator";
import {NetworkError} from "./NetworkError";
import {endpoints, http} from "../configs/https";

class Maal extends React.Component {
    constructor() {
        super();
        this.state = {
            annual_budget: 0,
            awareness: "",
            startDate: new Date(),
            chanda: 0,
            op_220: 0,
            tahrik: 0,
            review: 0,
            ijtema: 0,
            other: 0,
            details_att: "",
            phone: "",
            nazim_maal: "",
            isSubmitting: false,
            submitted: false,
            loading: true,
            modal: false,
            networkError: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.handleDate = this.handleDate.bind(this);
    }

    componentDidMount() {
        document.title = "MAAL - MKAN REPORT";
        this.setupValidator();
    }

    setupValidator() {
        this.setState({
            loading: false
        });
        const { year, month } = this.props.monthYear;
        const {failed} = this.props.status;
        if (failed){
            this.props.loadStatus(month,year);
        }
        this.validator = new SimpleReactValidator();
    }


    handleDate(date) {
        this.setState({
            startDate: date
        });
    }

    checkStatus() {
        const {month, year} = this.props.monthYear;
        axios
            .post(
                BASE_URL + `status/`,
                {month: month, year: year},
                {
                    headers: {Authorization: `Bearer ${this.props.user.token}`}
                }
            )
            .then(res => {
                if (res.data.maal) {
                    this.setState({
                        submitted: res.data.maal,
                        loading: false
                    });
                }
                this.setState({
                    loading: false
                });
            })
            .catch(error => {
                if (error.message === "Network Error") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.setState({
                        networkError: true
                    });

                    Toast.fire({
                        type: "warning",
                        title:
                            "Network error, try Reloading page. Possibly no internet connection "
                    });
                } else {
                    if (error.response.status === 401) {
                        this.props.logOutUser();
                        window.location.replace("/");
                        this.setState({});
                        const Toast = Swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000
                        });

                        Toast.fire({
                            type: "error",
                            title: "You need to log in again "
                        });
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000
                        });

                        Toast.fire({
                            type: "error",
                            title: "Something went wrong, try again."
                        });
                    }
                }
            });
    }

    onChangeFile(e) {
        this.setState({attachment: e.target.files[0]});
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const {month, year, monthName} = this.props.monthYear;
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
            return;
        }

        if (this.state.phone.length > 11) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
            });

            Toast.fire({
                type: "warning",
                title: "Nazim's phone number should not be greater than 11 characters"
            });
            return;
        }
        if (this.state.awareness == "") {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
            });

            Toast.fire({
                type: "warning",
                title: "State where there was awareness program or not"
            });
            return;
        }
        if (this.state.details_att === "") {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
            });

            Toast.fire({
                type: "warning",
                title: "State if you are attaching detailed maal report"
            });
            return;
        }

        Swal.fire({
            title:
                "Are you sure you want to submit your Maal report for " +
                monthName +
                " " +
                year +
                "?",
            text:
                "You won't be able to revert this after submitting, kindly check all details are accurate.",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Submit",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33"
        }).then(result => {
            if (result.value) {
                this.LoadingBar.staticStart(10);
                this.setState({
                    isSubmitting: true
                });
                const formData = new FormData();

                if (this.state.attachment != null)
                    formData.append("attachment", this.state.attachment);
                formData.append("annual_budget", this.state.annual_budget);
                formData.append(
                    "awareness",
                    this.state.awareness == "Yes" ? true : false
                );
                // if (this.state.awareness == "Yes")
                formData.append(
                    "date_observed",
                    moment(this.state.startDate).format("YYYY-MM-DD")
                );
                formData.append("chanda", this.state.chanda);
                formData.append("op_220", this.state.op_220);
                formData.append("tahrik", this.state.tahrik);
                formData.append("review", this.state.review);
                formData.append("ijtema", this.state.ijtema);
                formData.append("other", this.state.other);
                formData.append("month", month);
                formData.append("year", year);
                formData.append(
                    "details_att",
                    this.state.details_att == "Yes" ? true : false
                );

                formData.append("phone", this.state.phone);

                http.post(endpoints.MAAL,
                    formData, {'Content-Type': 'multipart/form-data'}
                )
                    .then(res => {
                        this.setState({
                            isSubmitting: false
                        });

                        if (res.status != 201) {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000
                            });

                            Toast.fire({
                                type: "warning",
                                title: "There is an error in your submission, try again"
                            });
                            this.LoadingBar.complete();
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000
                            });

                            Toast.fire({
                                type: "success",
                                title: "Maal report submitted successfully "
                            });
                            this.LoadingBar.complete();
                            this.setState({
                                modal: true
                            });
                            this.props.loadStatus(month,year);
                        }
                    })
                    .catch(error => {
                        this.setState({
                            isSubmitting: false
                        });
                        this.LoadingBar.complete();
                        let errorMessage =
                            (typeof error === "string" && error) ||
                            "An error occured, please try again in a moment.";

                        const Toast = Swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000
                        });

                        Toast.fire({
                            type: "error",
                            title: errorMessage
                        });
                        // alert(JSON.stringify(error));
                        console.log(errorMessage);
                    });
            }
        });
    }

    render() {
        const {year, monthName} = this.props.monthYear;
        const {data, isFetching, failed} = this.props.status;
        const {isSubmitting} = this.state;
        return (
            <div>

                {failed ? (
                    <NetworkError/>
                ) : (
                    <section className="content">
                        {" "}
                        {this.state.loading || isFetching ? (
                            <div>
                                <div className="spinner">
                                    <Loader
                                        type="ThreeDots"
                                        color="#00BFFF"
                                        height="40"
                                        width="40"
                                    />
                                </div>
                                {" "}
                            </div>
                        ) : (
                            <div>
                                {" "}
                                {!data.maal ? (
                                    <div>
                                        <LoadingBar onRef={ref => (this.LoadingBar = ref)}/>{" "}
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header card-header-primary">
                                                        <h4 className="card-title">
                                                            {" "}
                                                            MAAL(FINANCE) - {monthName}, {year}
                                                        </h4>{" "}
                                                        <p className="card-category">
                                                            {" "}
                                                            Complete the form below
                                                        </p>
                                                    </div>
                                                    <div className="card-body">
                                                        <form onSubmit={this.handleSubmit}>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            Annual Budget
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="annual_budget"
                                                                            name="annual_budget"
                                                                            value={this.state.annual_budget}
                                                                            onChange={this.handleChange}
                                                                        />{" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            Were there any awareness program on Maal
                                                                            observed ?
                                                                        </label>
                                                                        <div className="form-check">
                                                                            <label className="form-check-label">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    id=""
                                                                                    onChange={this.handleChange}
                                                                                    name="awareness"
                                                                                    value="Yes"
                                                                                />{" "}
                                                                                Yes{" "}
                                                                                <span className="form-check-sign">
                                          <span className="check"/>
                                        </span>{" "}
                                                                            </label>
                                                                            <label className="form-check-label">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    id="organized"
                                                                                    onChange={this.handleChange}
                                                                                    name="awareness"
                                                                                    value="No"
                                                                                />{" "}
                                                                                No{" "}
                                                                                <span className="form-check-sign">
                                          <span className="check"/>
                                        </span>{" "}
                                                                            </label>{" "}
                                                                        </div>
                                                                        {" "}
                                                                    </div>
                                                                    {" "}
                                                                    <span className="text-danger">
                                    {" "}
                                                                        {this.validator.message(
                                                                            "awareness",
                                                                            this.state.awareness,
                                                                            "required"
                                                                        )}{" "}
                                  </span>{" "}
                                                                </div>
                                                                {" "}
                                                            </div>
                                                            {" "}
                                                            <div className="row">
                                                                {" "}
                                                                {this.state.awareness == "Yes" ? (
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label className="bmd-label-floating">
                                                                                Date observed{" "}
                                                                            </label>
                                                                            <DatePicker
                                                                                selected={this.state.startDate}
                                                                                dateFormat="yyyy-MM-dd"
                                                                                onChange={this.handleDate}
                                                                            />{" "}
                                                                        </div>
                                                                        {" "}
                                                                    </div>
                                                                ) : (
                                                                    <div/>
                                                                )}{" "}
                                                            </div>
                                                            {" "}
                                                            <div className="row myborder">
                                                                <div className="col-md-12 mycenter">
                                                                    <h2> Summary of Maal report </h2>{" "}
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            Chanda{" "}
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="chanda"
                                                                            type="number"
                                                                            name="chanda"
                                                                            value={this.state.chanda}
                                                                            onChange={this.handleChange}
                                                                        />{" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            {" "}
                                                                            Operation 220
                                                                        </label>{" "}
                                                                        <input
                                                                            className="form-control"
                                                                            id="op_220"
                                                                            type="number"
                                                                            required
                                                                            name="op_220"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.op_220}
                                                                        />{" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            {" "}
                                                                            Tahrik - e - jadid
                                                                        </label>{" "}
                                                                        <input
                                                                            className="form-control"
                                                                            id="tahrik"
                                                                            type="number"
                                                                            required
                                                                            name="tahrik"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.tahrik}
                                                                        />{" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            {" "}
                                                                            Review of religion
                                                                        </label>{" "}
                                                                        <input
                                                                            className="form-control"
                                                                            id="review"
                                                                            type="number"
                                                                            required
                                                                            name="review"
                                                                            onChange={this.handleChange}
                                                                            value={this.state.review}
                                                                        />{" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <div className="form-group">
                                                                            <label className="bmd-label-floating">
                                                                                {" "}
                                                                                Ijtema
                                                                            </label>{" "}
                                                                            <input
                                                                                className="form-control"
                                                                                id="ijtema"
                                                                                type="number"
                                                                                required
                                                                                name="ijtema"
                                                                                onChange={this.handleChange}
                                                                                value={this.state.ijtema}
                                                                            />{" "}
                                                                        </div>
                                                                        {" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <div className="form-group">
                                                                            <label className="bmd-label-floating">
                                                                                Others
                                                                            </label>
                                                                            <input
                                                                                className="form-control"
                                                                                id="other"
                                                                                type="number"
                                                                                name="other"
                                                                                onChange={this.handleChange}
                                                                                value={this.state.other}
                                                                            />{" "}
                                                                        </div>
                                                                        {" "}
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                                {" "}
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            Has detailed Maal report been attached to
                                                                            this report ?
                                                                        </label>
                                                                        <div className="form-check">
                                                                            <label className="form-check-label">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    onChange={this.handleChange}
                                                                                    name="details_att"
                                                                                    value="Yes"
                                                                                />{" "}
                                                                                Yes{" "}
                                                                                <span className="form-check-sign">
                                          <span className="check"/>
                                        </span>{" "}
                                                                            </label>
                                                                            <label className="form-check-label">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    id=""
                                                                                    onChange={this.handleChange}
                                                                                    name="details_att"
                                                                                    value="No"
                                                                                />{" "}
                                                                                No{" "}
                                                                                <span className="form-check-sign">
                                          <span className="check"/>
                                        </span>{" "}
                                                                            </label>{" "}
                                                                        </div>
                                                                        {" "}
                                                                    </div>
                                                                    {" "}
                                                                    <span className="text-danger">
                                    {" "}
                                                                        {this.validator.message(
                                                                            "report",
                                                                            this.state.details_att,
                                                                            "required"
                                                                        )}{" "}
                                  </span>{" "}
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="bmd-label-floating">
                                                                            Nazim Maal 's Phone{" "}
                                                                        </label>
                                                                        <input
                                                                            type="tel"
                                                                            className="form-control"
                                                                            id="phone"
                                                                            name="phone"
                                                                            value={this.state.phone}
                                                                            onChange={this.handleChange}
                                                                        />{" "}
                                                                    </div>
                                                                    {" "}
                                                                    <span className="text-danger">
                                    {" "}
                                                                        {this.validator.message(
                                                                            "nazim maal's phone number",
                                                                            this.state.phone,
                                                                            "required|min:5|max:11"
                                                                        )}{" "}
                                  </span>{" "}
                                                                </div>
                                                                {" "}
                                                            </div>
                                                            {" "}
                                                            <div className="row">
                                                                <div className="col-md-4 col-sm-4">
                                                                    <h4 className="title">
                                                                        Attachment(Please attach detailed maal
                                                                        report){" "}
                                                                    </h4>
                                                                    <input
                                                                        type="file"
                                                                        onChange={this.onChangeFile}
                                                                    />{" "}
                                                                </div>
                                                                {" "}
                                                            </div>
                                                            {isSubmitting ? <Loading/> : ""}
                                                            <button
                                                                type="submit"
                                                                className="btn btn-success pull-right"
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? "Loading..." : "Submit"}{" "}
                                                            </button>
                                                            {" "}
                                                            <div className="clearfix"/>
                                                        </form>
                                                        {" "}
                                                    </div>
                                                    {" "}
                                                </div>
                                                {" "}
                                            </div>
                                            {" "}
                                        </div>
                                        {" "}
                                        <div/>
                                    </div>
                                ) : (
                                    <div className="d-flex align-items-center">
                                        <h2>
                                            {" "}
                                            You already submitted Maal report for{" "}
                                            <b>
                                                {monthName}, {year}
                                            </b>
                                        </h2>{" "}
                                    </div>
                                )}{" "}
                            </div>
                        )}{" "}
                    </section>
                )}
            </div>
        );
    }
}

Maal.propTypes = {
    createUser: PropTypes.func.isRequired,
    logOutUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
    user: state.person.user,
    isLoggedIn: state.person.isLoggedIn,
    monthYear: state.currentMonth.monthYear,
    status: state.status,
});

export default connect(mapStateToProps, {createUser, logOutUser, loadStatus})(Maal);
